/**
 * @generated SignedSource<<b851bf88aff54b565e818640b1951d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StaffSelectPageMask_barFinderBar$data = {
  readonly bar_id: string;
  readonly confidence: number;
  readonly mask_download_url: string;
  readonly " $fragmentType": "StaffSelectPageMask_barFinderBar";
};
export type StaffSelectPageMask_barFinderBar$key = {
  readonly " $data"?: StaffSelectPageMask_barFinderBar$data;
  readonly " $fragmentSpreads": FragmentRefs<"StaffSelectPageMask_barFinderBar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StaffSelectPageMask_barFinderBar",
  "selections": [
    {
      "alias": "bar_id",
      "args": null,
      "kind": "ScalarField",
      "name": "mask_storage_name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "confidence",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mask_download_url",
      "storageKey": null
    }
  ],
  "type": "MusicParseStepDataBarFinderBar",
  "abstractKey": null
};

(node as any).hash = "c2d7153dc943592fc53ced2a13f3c162";

export default node;
